<template>
    <div class="device-info f-c-midgrey f-12 f-regular">
        <div class="no-telp" v-if="number">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.02621 0.333292C3.38621 0.333292 0.419544 3.29996 0.419544 6.93996C0.419544 8.10662 0.726211 9.23996 1.29954 10.24L0.366211 13.6666L3.86621 12.7466C4.83288 13.2733 5.91954 13.5533 7.02621 13.5533C10.6662 13.5533 13.6329 10.5866 13.6329 6.94662C13.6329 5.17996 12.9462 3.51996 11.6995 2.27329C11.0883 1.65591 10.3603 1.1664 9.55797 0.833326C8.75561 0.500248 7.89496 0.330265 7.02621 0.333292ZM7.03288 1.44662C8.49954 1.44662 9.87288 2.01996 10.9129 3.05996C11.4233 3.57019 11.8279 4.17617 12.1037 4.84313C12.3794 5.51009 12.5207 6.22492 12.5195 6.94662C12.5195 9.97329 10.0529 12.4333 7.02621 12.4333C6.03954 12.4333 5.07288 12.1733 4.23288 11.6666L4.03288 11.5533L1.95288 12.1L2.50621 10.0733L2.37288 9.85996C1.82217 8.98574 1.53089 7.97317 1.53288 6.93996C1.53954 3.91329 3.99954 1.44662 7.03288 1.44662ZM4.68621 3.88662C4.57954 3.88662 4.39954 3.92662 4.24621 4.09329C4.09954 4.25996 3.66621 4.66662 3.66621 5.47329C3.66621 6.28662 4.25954 7.06662 4.33288 7.17996C4.42621 7.29329 5.50621 8.95996 7.16621 9.66662C7.55954 9.84662 7.86621 9.94662 8.10621 10.02C8.49954 10.1466 8.85954 10.1266 9.14621 10.0866C9.46621 10.04 10.1195 9.68662 10.2595 9.29996C10.3995 8.91329 10.3995 8.58662 10.3595 8.51329C10.3129 8.44662 10.2062 8.40662 10.0395 8.33329C9.87288 8.23996 9.05954 7.83996 8.91288 7.78662C8.75954 7.73329 8.66621 7.70662 8.53954 7.86662C8.43288 8.03329 8.11288 8.40662 8.01954 8.51329C7.91954 8.62662 7.82621 8.63996 7.66621 8.55996C7.49288 8.47329 6.95954 8.29996 6.33288 7.73996C5.83954 7.29996 5.51288 6.75996 5.41288 6.59329C5.33288 6.43329 5.40621 6.33329 5.48621 6.25996C5.55954 6.18662 5.66621 6.06662 5.73288 5.96662C5.81954 5.87329 5.84621 5.79996 5.89954 5.69329C5.95288 5.57996 5.92621 5.48662 5.88621 5.40662C5.84621 5.33329 5.51288 4.50662 5.37288 4.17996C5.23954 3.85996 5.10621 3.89996 4.99954 3.89329C4.90621 3.89329 4.79954 3.88662 4.68621 3.88662Z"
                    fill="#6F7287"
                />
            </svg>
            <span class="m-l-4">{{ number }}</span>
        </div>
        <label class="m-d-0">{{ name }}</label>
    </div>
</template>
<script>
export default {
    name: "DeviceInfo",
    props: {
        number: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
    },
};
</script>
<style scoped>
.device-info {
    padding: 0px 20px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    width: 100%;
}
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}
</style>
